import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

/**
 * Eligibility for Standard edition PaymentFlowLink (Jira/Confluence in trial or predunning).
 */
export function isEligibleForStandardPaymentFlowLink(
	context: EditionAwarenessContextType,
): boolean {
	const {
		product,
		edition,
		isInTrial,
		isInPredunning,
		invoiceableStatus,
		canAddPaymentDetails,
		addPaymentDetailsExperienceUrl,
		isInCollection,
	} = context;

	return Boolean(
		!isInCollection &&
		isEditionOneOf(edition, ['standard']) &&
		(isInTrial || isInPredunning) &&
		invoiceableStatus === 'NOT_INVOICEABLE' &&
		canAddPaymentDetails &&
		isProductOneOf(product, ['jira', 'confluence']) &&
		addPaymentDetailsExperienceUrl,
	);
}
